import { commonTypes } from '../common';

const types = {
  SET_ACTIVE_OBD: 'APISNEEDSOBD/SET_ACTIVE_OBD',
};

export const initialState = {
  obd: {
    activeOBD: false,
    blockedByOBD: false,
    validLines: null,
  },
};

const ApisNeedsOBDReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_OBD_LINES: {
      const { lines } = action.payload;

      return {
        ...state,
        obd: {
          ...state.obd,
          validLines: lines,
        },
      };
    }
    case commonTypes.SET_BLOCKED_BY_OBD_STATUS: {
      const { status } = action.payload;

      return {
        ...state,
        obd: {
          ...state.obd,
          blockedByOBD: status,
        },
      };
    }
    case types.SET_ACTIVE_OBD: {
      return {
        ...state,
        obd: {
          activeOBD: true,
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setActiveOBD: () => ({
    type: types.SET_ACTIVE_OBD,
  }),
};

export default ApisNeedsOBDReducer;
